
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/saudi-rewards/retro-redeem",
      function () {
        return require("private-next-pages/saudi-rewards/retro-redeem/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/saudi-rewards/retro-redeem"])
      });
    }
  